import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import webtmsBackend from './services/webtmsBackend';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    modules: ['local'],
    storage: window.localStorage,
});

const vuexSession = new VuexPersistence({
    modules: ['session'],
    storage: window.sessionStorage,
});

const local = {
    state: () => ({
        isLoggedIn: false,
        user: {},
        userOptions: [],
        userPermissions: [],
        userMessagesView: {},
        company: {},
        companyOptions: [],
        companyPermissions: [],
        navbarMini: false,
        navdrawerOpen: false,
        systemVariables: [],
        ticketAlerts: [],
        onlineSince: null,
        offlineSince: null,
        lostInternet: false,
        forceOffline: false,
        cachingOfflineData: false,
        cachingOfflineDataProgress: 0,
        offlineResponses: [],
        offlineResponseStatuses: [],
        showUploadOfflineDialog: false,
        uploadingOfflineResponses: false,
        offlineImageCount: 0,
        offlineImages: [],
        offlineImageStatuses: [],
        alertsAudioOn: true,
        snackbars: [],
        overviewOpenTickets: {},
        companyCenters: [],
        companyBilling: [],
        companyLayers: [],
        companyMemberCodes: [],   
        riskOptions: ['HIGH', 'MODERATE', 'NORMAL'],
        companyTicketPriorities: [],
        companyTicketTypes: [],
        counties: [],
        companyUsers: [],
        companyUsersDeleted: [],
        columnsCatalog: [],
        activeTab: {},
        tabSelectedItems: {},
        ticketMapTickets: [],
        companyResponseCodes: [],
        centersPosRespCodes: [],
        companyPositiveResponseMap: [],
        itemsPerPage: null,
        revisionDetails: {},
        userClipboard: [],
        editUser: [],
        alertPreferences: {},
        companyTicketCategories: [],
        centers: [],
        selectedAutoResponseRule: {},
        layerId: 0,
        companyEmailSupplemental: [],
        selectedAutoAssignRule: {},
        selectedEmailSupplementalRule: {},
        reportList: [],
        sysReports: [],        
    }),
    mutations: {
        SET_IS_LOGGED_IN: (state, isLoggedIn) => {
            state.isLoggedIn = isLoggedIn;
        },
        SET_USER: (state, user) => {
            state.user = user;
        },
        SET_USER_OPTIONS: (state, userOptions) => {
            state.userOptions = userOptions;
        },
        SET_USER_PERMISSIONS: (state, userPermissions) => {
            state.userPermissions = userPermissions;
        },
        SET_USER_MESSAGES_VIEW: (state, userMessagesView) => {
            state.userMessagesView = userMessagesView;
        },
        SET_COMPANY: (state, company) => {
            state.company = company;
        },
        SET_COMPANY_OPTIONS: (state, companyOptions) => {
            state.companyOptions = companyOptions;
        },
        SET_COMPANY_PERMISSIONS: (state, companyPermissions) => {
            state.companyPermissions = companyPermissions;
        },
        SET_NAVBAR_MINI: (state, navbarMini) => {
            state.navbarMini = navbarMini;
        },
        SET_NAVDRAWER_OPEN: (state, navdrawerOpen) => {
            state.navdrawerOpen = navdrawerOpen;
        },
        SET_SYSTEM_VARIABLES: (state, systemVariables) => {
            state.systemVariables = systemVariables;
        },
        SET_TICKET_ALERTS: (state, ticketAlerts) => {
            const localTicketAlerts = ticketAlerts.map((ticketAlert) => {
                if (ticketAlert.member_codes && ticketAlert.member_codes.split) {
                    ticketAlert.member_codes = ticketAlert.member_codes.split(',');
                } else {
                    ticketAlert.member_codes = [];
                }
                ticketAlert.alert_date = new Date(ticketAlert.alert_date);
                return ticketAlert;
            });
            state.ticketAlerts = localTicketAlerts;
        },
        SET_ALERTS_AUDIO_ON: (state, alertsAudioOn) => {
            state.alertsAudioOn = alertsAudioOn;
        },
        SET_ONLINE_SINCE: (state, onlineSince) => {
            state.onlineSince = onlineSince;
        },
        SET_OFFLINE_SINCE: (state, offlineSince) => {
            state.offlineSince = offlineSince;
        },
        SET_LOST_INTERNET: (state, lostInternet) => {
            state.lostInternet = lostInternet;
        },
        SET_FORCE_OFFLINE: (state, forceOffline) => {
            state.forceOffline = forceOffline;
        },
        SET_CACHING_OFFLINE_DATA: (state, cachingOfflineData) => {
            state.cachingOfflineData = cachingOfflineData;
        },
        SET_CACHING_OFFLINE_DATA_PROGRESS: (state, cachingOfflineDataProgress) => {
            state.cachingOfflineDataProgress = cachingOfflineDataProgress;
        },
        SET_OFFLINE_RESPONSES: (state, offlineResponses) => {
            state.offlineResponses = offlineResponses;
        },
        SET_OFFLINE_RESPONSES_STATUSES: (state, offlineResponseStatuses) => {
            state.offlineResponseStatuses = offlineResponseStatuses;
        },
        SET_SHOW_UPLOAD_OFFLINE_DIALOG: (state, showUploadOfflineDialog) => {
            state.showUploadOfflineDialog = showUploadOfflineDialog;
        },
        SET_UPLOADING_OFFLINE_RESPONSES: (state, uploadingOfflineResponses) => {
            state.uploadingOfflineResponses = uploadingOfflineResponses;
        },
        SET_OFFLINE_IMAGE_COUNT: (state, offlineImageCount) => {
            state.offlineImageCount = offlineImageCount;
        },
        SET_OFFLINE_IMAGES: (state, offlineImages) => {
            state.offlineImages = offlineImages;
        },
        SET_OFFLINE_IMAGES_STATUSES: (state, offlineImageStatuses) => {
            state.offlineImageStatuses = offlineImageStatuses;
        },
        SET_USER_EMAIL: (state, email) => {
            state.user.email = email;
        },
        SET_EMAIL_TICKET_FORMAT: (state, ticketFormat) => {
            state.user.EMAIL_TICKET_FORMAT = ticketFormat;
        },
        SET_SNACKBAR: (state, snackbar) => {
            // remove any previously showing snackbars
            let oldsbs = state.snackbars.filter(sb => sb.showing === false);
            oldsbs.forEach(sb => state.snackbars.splice(state.snackbars.findIndex(e => e.showing === sb.showing), 1));
            state.snackbars = state.snackbars.concat(snackbar);
        },
        SET_OVER_VIEW_OPEN_TICKETS: (state, overviewOpenTickets) => {
            state.overviewOpenTickets = overviewOpenTickets;
        },
        SET_COMPANY_CENTERS: (state, companyCenters) => {
            state.companyCenters = companyCenters;
        },
        SET_COMPANY_BILLING: (state, companyBilling) => {
            state.companyBilling = companyBilling;
        },
        SET_COMPANY_LAYERS: (state, companyLayers) => {
            state.companyLayers = companyLayers;
        },
        SET_COMPANY_MEMBER_CODES: (state, companyMemberCodes) => {
            state.companyMemberCodes = companyMemberCodes;
        },        
        SET_COMPANY_TICKET_PRIORITES: (state, companyTicketPriorities) => {
            state.companyTicketPriorities = companyTicketPriorities;
        },
        SET_COMPANY_TICKET_TYPES: (state, companyTicketTypes) => {
            state.companyTicketTypes = companyTicketTypes;
        },
        SET_COUNTIES: (state, counties) => {
            state.counties = counties;
        },
        SET_COMPANY_USERS: (state, companyUsers) => {
            state.companyUsers = companyUsers;
        },
        SET_COMPANY_USERS_DELETED: (state, companyUsersDeleted) => {
            state.companyUsersDeleted = companyUsersDeleted;
        },
        SET_COLUMNS_CATALOG: (state, ticketColumnsCatalog) => {
            state.ticketColumnsCatalog = ticketColumnsCatalog;
        },       
        SET_ACTIVE_TAB: (state, activeTab) => {
            state.activeTab = activeTab;
        },
        SET_TAB_SELECTED_ITEMS: (state, tabSelectedItems) => {
            state.tabSelectedItems = tabSelectedItems;
        },
        SET_TICKET_MAP_TICKETS: (state, tickets) => {
            state.ticketMapTickets = tickets;
        },
        SET_COMPANY_RESPONSE_CODES: (state, companyResponseCodes) => {
            state.companyResponseCodes = companyResponseCodes;
        },
        SET_CENTERS_RESPONSE_CODES: (state, centersPosRespCodes) => {
            state.centersPosRespCodes = centersPosRespCodes;
        },
        SET_COMPANY_RESPONSE_MAP: (state, companyPositiveResponseMap) => {
            state.companyPositiveResponseMap = companyPositiveResponseMap;
        },
        SET_ITEMS_PER_PAGE: (state, itemsPerPage) => {
            state.itemsPerPage = itemsPerPage;
        },
        SET_REVISION_DETAILS: (state, details) => {
            state.revisionDetails = details;
        },
        SET_USER_CLIPBOARD: (state, userClipboard) => {
            state.userClipboard = userClipboard;
        },
        SET_EDIT_USER: (state, editUser) => {
            state.editUser = editUser;
        },
        SET_ALERT_PREFEREENCES: (state, alertPreferences) => {
            state.alertPreferences = alertPreferences;
        },
        SET_COMPANY_TICKET_CATEGORIES: (state, companyTicketCategories) => {
            state.companyTicketCategories = companyTicketCategories;
        },
        SET_CENTER: (state, centers) => {
            state.centers = centers;
        },
        SET_USER_PERMISSIONS_CATALOG: (state, userPermissionsCatalog) => {
            state.userPermissionsCatalog = userPermissionsCatalog;
        },
        SET_SELECTED_AUTO_RESPONSE_RULE: (state, selectedAutoResponseRule) => {
            state.selectedAutoResponseRule = selectedAutoResponseRule;
        },
        SET_LAYER_ID: (state, layerId) => {
            state.layerId = layerId;
        },
        SET_COMPANY_EMAIL_SUPPLEMENTAL: (state, companyEmailSupplemental) => {
            state.companyEmailSupplemental = companyEmailSupplemental;
        },
        SET_SELECTED_AUTO_ASSIGN_RULE: (state, selectedAutoAssignRule) => {
            state.selectedAutoAssignRule = selectedAutoAssignRule;
        },
        SET_SELECTED_EMAIL_SUPPLEMENTAL_RULE: (state, selectedEmailSupplementalRule) => {
            state.selectedEmailSupplementalRule = selectedEmailSupplementalRule;
        },
        SET_REPORTS: (state, reportList) => {
            state.reportList = reportList;
        },
        SET_SYS_REPORTS: (state, sysReports) => {
            state.sysReports = sysReports;
        },         
    },
    actions: {
        updateUserEmail({ commit }, email) {
            commit('SET_USER_EMAIL', email);
        },
        updateUserEmailTicketFormat({ commit }, ticketFormat) {
            commit('SET_EMAIL_TICKET_FORMAT', ticketFormat);
        },
        setSnackbar({ commit }, snackbar) {
            snackbar.showing = true;
            snackbar.color = snackbar.color || 'success';
            snackbar.backgroundColor = snackbar.backgroundColor || '#49C84F';
            snackbar.timeout = snackbar.timeout || 6000;
            commit('SET_SNACKBAR', snackbar);
        },
        setConfigOrderByDefault({ commit }, orderByDefault) {
            commit('SET_CONFIG_ORDER_BY_DEFAULT', orderByDefault);
        },
        setConfigRefreshMinutes({ commit }, refreshMinutes) {
            commit('SET_CONFIG_REFRESH_MINUTES', refreshMinutes);
        },
        setConfigFields({ commit }, fields) {
            commit('SET_CONFIG_FIELDS', fields);
        },

        async updateUserOptions({ commit }, options) {
            // save new options
            let setOptionResponse = await webtmsBackend.setUserOptions(options);
            if (setOptionResponse.failed.length) {
                for (let error of setOptionResponse.failed) {
                    console.error(`updateUserOptions failed with:`, error);
                }
                return;
            }
            // fetch changes
            const userOptions = await webtmsBackend.getUserOptions();
            commit('SET_USER_OPTIONS', userOptions.userOptions);
        },
        setTicketMapTickets({ commit }, tickets) {
            commit('SET_TICKET_MAP_TICKETS', tickets);
        },
        setItemsPerPage({ commit }, itemsPerPage) {
            commit('SET_ITEMS_PER_PAGE', itemsPerPage);
        },
        async updateUserClipboard({ commit }, update) {
            if (update.add) {
                let clipboard = await webtmsBackend.updateClipboardItem(
                    'add',
                    update.add
                );
                commit('SET_USER_CLIPBOARD', clipboard.data);
            }
            if (update.remove) {
                let clipboard = await webtmsBackend.updateClipboardItem(
                    'remove',
                    update.remove
                );
                commit('SET_USER_CLIPBOARD', clipboard.data);
            }
        },
        async setUserClipboardOrder({ commit }, trRowIds) {
            let clipboard = await webtmsBackend.updateClipboardItem(
                'set',
                trRowIds
            );
            commit('SET_USER_CLIPBOARD', clipboard.data);
        },
        async loadTicketPageData({ commit }) {
            const ticketPageData = await webtmsBackend.getTicketPageData();
            commit('SET_COMPANY', ticketPageData.company);
            commit('SET_USER_OPTIONS', ticketPageData.userOptions);
            commit(
                'SET_OVER_VIEW_OPEN_TICKETS',
                ticketPageData.overviewOpenTickets
            );
            commit('SET_USER_PERMISSIONS', ticketPageData.userPermissions);
            commit('SET_COMPANY_OPTIONS', ticketPageData.companyOptions);
            commit('SET_COMPANY_PERMISSIONS', ticketPageData.companyPermissions);
            commit(
                'SET_COMPANY_TICKET_PRIORITES',
                ticketPageData.companyTicketPriorities
            );
            commit('SET_COMPANY_TICKET_TYPES', ticketPageData.companyTicketTypes);
            commit('SET_COLUMNS_CATALOG', ticketPageData.ticketColumnsCatalog);
            commit(
                'SET_COMPANY_RESPONSE_CODES',
                ticketPageData.companyResponseCodes
            );
            commit(
                'SET_CENTERS_RESPONSE_CODES',
                ticketPageData.centersPosRespCodes
            );
            commit(
                'SET_COMPANY_RESPONSE_MAP',
                ticketPageData.companyPositiveResponseMap
            );
            commit('SET_USER_CLIPBOARD', ticketPageData.userClipboard);
            commit('SET_COMPANY_CENTERS', ticketPageData.companyCenters);
            commit('SET_COMPANY_BILLING', ticketPageData.companyBilling);
        },
        setAlertAudio({ commit }, alertsEnabled) {
            commit('SET_ALERTS_AUDIO_ON', alertsEnabled);
        },
        setAlertPreferences({ commit }, options) {
            commit('SET_ALERT_PREFEREENCES', options);
        },
        async updateCompanyLayers({ commit }, options) {
            // save new options
            let setLayersResponse = await webtmsBackend.addMapLayer(options);
            if (setLayersResponse.failed.length) {
                for (let error of setLayersResponse.failed) {
                    console.error(`setLayersResponse failed with:`, error);
                }
                return;
            }
            // fetch changes
            const companyLayers = await webtmsBackend.getCompanyLayersEx();
            commit('SET_COMPANY_LAYERS', companyLayers);
        },
        async updateCompanyEmailSupplemental({ commit }) {
            const companyEmailSupplemental = await webtmsBackend.getCompanyEmailSupplemental();
            commit('SET_COMPANY_EMAIL_SUPPLEMENTAL', companyEmailSupplemental);
        },
        async updateBillingCode({ commit }, options) {
            // save new options
            let updateBillingCodeResponse = await webtmsBackend.updateBillingCode(options);
            commit('SET_COMPANY_BILLING', updateBillingCodeResponse.billing);           
        },
    
        async getCompanyBilling({ commit }) {
            const companyBilling = await webtmsBackend.getCompanyBilling();
            commit('SET_COMPANY_BILLING', companyBilling);
        },
        async updateResponses({ commit }, options) {
            // save new options
            let updateResponseCodeResponse = await webtmsBackend.updateResponseCode(options);
            commit('SET_COMPANY_RESPONSE_CODES', updateResponseCodeResponse.responseCodes);
        }
    },
    getters: {
        isLoggedIn: (state) => state.isLoggedIn,
        snackbars: (state) => state.snackbars,
        user: (state) => state.user,
        userOptions: (state) => state.userOptions,
        userPermissions: (state) => state.userPermissions,
        userMessagesView: (state) => state.userMessagesView,
        company: (state) => state.company,
        companyOptions: (state) => state.companyOptions,
        companyPermissions: (state) => state.companyPermissions,
        navbarMini: (state) => state.navbarMini,
        navdrawerOpen: (state) => state.navdrawerOpen,
        systemVariables: (state) => state.systemVariables,
        ticketAlerts: (state) => state.ticketAlerts,
        onlineSince: (state) => state.onlineSince,
        offlineSince: (state) => state.offlineSince,
        lostInternet: (state) => state.lostInternet,
        forceOffline: (state) => state.forceOffline,
        cachingOfflineData: (state) => state.cachingOfflineData,
        cachingOfflineDataProgress: (state) => state.cachingOfflineDataProgress,
        offlineResponses: (state) => state.offlineResponses,
        offlineResponseStatuses: (state) => state.offlineResponseStatuses,
        showUploadOfflineDialog: (state) => state.showUploadOfflineDialog,
        uploadingOfflineResponses: (state) => state.uploadingOfflineResponses,
        offlineImageCount: (state) => state.offlineImageCount,
        offlineImages: (state) => state.offlineImages,
        offlineImageStatuses: (state) => state.offlineImageStatuses,
        alertsAudioOn: (state) => state.alertsAudioOn,
        overviewOpenTickets: (state) => state.overviewOpenTickets,
        companyCenters: (state) => state.companyCenters,
        companyLayers: (state) => state.companyLayers,
        companyMemberCodes: (state) => state.companyMemberCodes,
        companyBilling: (state) => state.companyBilling,
        riskOptions: (state) => state.riskOptions,
        companyTicketPriorities: (state) => state.companyTicketPriorities,
        companyTicketTypes: (state) => state.companyTicketTypes,
        counties: (state) => state.counties,
        companyUsers: (state) => state.companyUsers,
        companyUsersDeleted: (state) => state.companyUsersDeleted,
        columnsCatalog: (state) => state.ticketColumnsCatalog,
        activeTab: (state) => state.activeTab,
        tabSelectedItems: (state) => state.tabSelectedItems,
        ticketMapTickets: (state) => state.ticketMapTickets,
        companyResponseCodes: (state) => state.companyResponseCodes,
        centersPosRespCodes: (state) => state.centersPosRespCodes,
        companyPositiveResponseMap: (state) => state.companyPositiveResponseMap,
        itemsPerPage: (state) => state.itemsPerPage,
        revisionDetails: (state) => state.revisionDetails,
        userClipboard: (state) => state.userClipboard,
        editUser: (state) => state.editUser,
        alertPreferences: (state) => state.alertPreferences,
        companyTicketCategories: (state) => state.companyTicketCategories,
        centers: (state) => state.centers,
        userPermissionsCatalog: (state) => state.userPermissionsCatalog,
        selectedAutoResponseRule: (state) => state.selectedAutoResponseRule,
        layerId: (state) => state.layerId,
        companyEmailSupplemental: (state) => state.companyEmailSupplemental,
        selectedAutoAssignRule: (state) => state.selectedAutoAssignRule,
        selectedEmailSupplementalRule: (state) => state.selectedEmailSupplementalRule,
        reportList: (state) => state.reportList,
        ticketColumnsCatalog: (state) => state.ticketColumnsCatalog,
        sysReports: (state) => state.sysReports,        
    },
};

const session = {
    state: ()=>({
        ticketDetails: {},
        ticketResponsesBilling: [],       
    }),
    mutations: {
        SET_TICKET_DETAILS(state, ticketDetails){
            state.ticketDetails = ticketDetails;
        },       
    },
    actions: {
        setTicketDetails({ commit }, ticketDetails){
            commit('SET_TICKET_DETAILS', ticketDetails);            
        }, 
        updateTicketResponsesBilling({ commit, state },  ticket_responses_billing) {          
            const ticketDetails = state.ticketDetails;
            ticketDetails.Ticket_ResponsesBilling = ticket_responses_billing; 
            commit('SET_TICKET_DETAILS', ticketDetails);
        }     
    },
    getters: {
        ticketDetails: (state) => state.ticketDetails,
        ticketResponsesBilling: (state) => state.ticketDetails?.Ticket_ResponsesBilling,        
    },
};

export default new Vuex.Store({
    modules:{ local, session },
    plugins: [vuexLocal.plugin, vuexSession.plugin]
});
